import { gql } from '@apollo/client';
export const CREATE_ORDER = gql`
    mutation CreateOrder(
        $event: String!,
        $comment: String!,
        $customerPhone: String!,
        $customerBirthday: String!,
        $customerName: String!,
        $customerSurname: String!, 
        $customerSex: String!,
        $customerEmail: String!,
        $customerSkype: String!
        $saleSum: Int,
        $pairVisit: Boolean,
        $system: String = "A"
    ) {
        createOrder(
            event: $event,
            comment: $comment,
            saleSum: $saleSum,
            pairVisit: $pairVisit,
            system: $system,
            customerData: {
                customerPhone: $customerPhone,
                customerBirthday: $customerBirthday,
                customerName: $customerName,
                customerSurname: $customerSurname, 
                customerSex: $customerSex,
                customerEmail: $customerEmail,
                customerSkype: $customerSkype 
            }
        ) {
            order{
                id
                createdAt
                pairVisit
                customer {
                    ask
                    user {
                        username
                    }
                }
                ticketSet {
                    edges {
                        node {
                            id
                        }  
                    }
                }
                service {
                    id
                    meetingType
                }
                specialist {
                    id
                    photo
                    photoResized
                    name
                    specialisation
                    skype
                    slug
                    user {
                        username 
                    }
                }
                event {
                    id
                    address {
                      id
                      address
                      town
                      district
                      parking
                      shema
                      tfm
                    }
                    videoCallUrl
                    accessToken
                    accessTokenClient
                    roomId
                    roomPassword
                    startDate
                    endDate
                }
                payment {
                   id
                   status
                   alfa {
                       payUrl
                   }
                   yandex {
                       payUrl
                   }
                }
            }
            error
        }
    } `;

export const GET_ONE_ORDER = gql`
query getOneOrder($id: ID!) {
    allOrders(id: $id) {
      edges {
        node {
          id
          source
          payUntil
          service {
            id
            meetingType
          }
          meetingStatus
          specialist {
            id
            photo
            name
            skype
            pairDetails
            photoResized
            user {
              username
            }
          }
          customer {
            user {
              username
            }
          }
          event {
            id
            address {
              id
              address
              town
              parking
              shema
              tfm
              coords
            }
            videoCallUrl
            accessToken
            accessTokenClient
            roomId
            roomPassword
            startDate
            endDate
          }
          payment {
            id
            status
            amount
            alfa {
              id
              payUrl 
            }
          }
        }
      }
    }
}`;
